import Area from '@/models/Area';
import LessonProgressDashboardStats from '@/models/LessonProgressDashboardStats';

export const COURSE_TRACK_PAGE_SIZE = 10;

export type CourseTrackLesson = {
  lessonId: number;
  name: string;
  order: number;
  description: string;
  bannerImg?: string;
  unitOrder?: number;
  areas: Pick<Area, 'id' | 'name'>[];
};

export const toCourseTrackLesson = ({
  lesson,
}: LessonProgressDashboardStats): CourseTrackLesson => ({
  lessonId: lesson.id,
  name: lesson.name,
  order: lesson.order,
  description: lesson.description,
  bannerImg: lesson.bannerImg,
  unitOrder: lesson.lessonBlock?.order,
  areas: lesson.areas,
});
